/**
 * Frontend view script — subtle parallax on scroll (desktop only).
 */

const BLOCK_SELECTOR = '.wp-block-alteia-cta-bg-section.alteia-cta-bg-section';
const PARALLAX_MAX_OFFSET = 24;
const MOBILE_BREAKPOINT = 781;

/**
 * @param {HTMLElement} block Root block element.
 * @return {void}
 */
function initParallax( block ) {
	const media = block.querySelector( '.alteia-cta-bg-section__media' );

	if ( ! media ) {
		return;
	}

	let ticking = false;

	const updateParallax = () => {
		const rect = media.getBoundingClientRect();
		const viewportHeight = window.innerHeight;
		const visibleRatio =
			1 -
			Math.abs( rect.top + rect.height / 2 - viewportHeight / 2 ) /
				viewportHeight;
		const clampedRatio = Math.max( 0, Math.min( 1, visibleRatio ) );
		const offset = ( clampedRatio - 0.5 ) * PARALLAX_MAX_OFFSET;

		media.style.setProperty(
			'--alteia-cta-bg-section-parallax',
			`${ offset.toFixed( 2 ) }px`
		);
		ticking = false;
	};

	const onScroll = () => {
		if ( ! ticking ) {
			ticking = true;
			window.requestAnimationFrame( updateParallax );
		}
	};

	updateParallax();
	window.addEventListener( 'scroll', onScroll, { passive: true } );
	window.addEventListener( 'resize', onScroll, { passive: true } );
}

/**
 * @return {void}
 */
function init() {
	if (
		window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ||
		window.innerWidth <= MOBILE_BREAKPOINT
	) {
		return;
	}

	document.querySelectorAll( BLOCK_SELECTOR ).forEach( initParallax );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
